import { render, staticRenderFns } from "./ZaloModal.vue?vue&type=template&id=3a65ea23&scoped=true"
import script from "./ZaloModal.vue?vue&type=script&lang=js"
export * from "./ZaloModal.vue?vue&type=script&lang=js"
import style0 from "./ZaloModal.vue?vue&type=style&index=0&id=3a65ea23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65ea23",
  null
  
)

export default component.exports